import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { LoadingContainerComponent } from './loading-container.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        LoadingContainerComponent
    ],
    exports: [
        LoadingContainerComponent
    ]
})
export class LoadingContainerComponentModule { }
